import * as React from 'react';
import Link from 'next/link';

import { GetAssetResponse } from '@blockworks/platform/api/research/assets';
import { Bit } from '@blockworks/ui/bit';
import { formatPercent, formatUsdLong } from '@blockworks/ui/charts/utils';
import { Avatar, Disclosure, FlexBox, Text } from '@blockworks/ui/components';

import AssetPriceChart from '@/components/asset-widget/asset-price-chart';
import MetricValue from '@/components/metrics/metric-value';

interface AssetWidgetProps {
    initiallyExpanded?: boolean;
    asset: GetAssetResponse['data'];
}

const AssetWidget = ({ asset, initiallyExpanded = false }: AssetWidgetProps) => {
    const [expanded, setExpanded] = React.useState(initiallyExpanded);

    const content = (
        <Disclosure
            expanded={expanded}
            onValueChange={id => setExpanded(!!id)}
            id={asset.code}
            content={() => <AssetPriceChart key={asset.cgRef} asset={asset} />}
        >
            <FlexBox pl={2} gap="md" flexGrow={1} w="full">
                <FlexBox center>
                    {asset.imageUrl && <Avatar size={24} src={asset.imageUrl} alt={asset.title} />}
                </FlexBox>
                <Bit.div>
                    <Link href={`/assets/${asset.code}`}>
                        <Text size="xs" weight="semibold" inline>
                            {asset.code}
                        </Text>{' '}
                        <Text size="xs" color="deselect" inline>
                            {asset.title}
                        </Text>
                    </Link>
                    <FlexBox alignItems="center" gap="xs">
                        <MetricValue size="xs" format={formatUsdLong} value={asset.price.usd} />
                        <MetricValue size="xs" format={formatPercent} value={asset.change.usd24h} showChangeDirection />
                    </FlexBox>
                </Bit.div>
            </FlexBox>
        </Disclosure>
    );

    return content;
};

export default AssetWidget;
